/**
 * @generated SignedSource<<f61524bfde2014531d714c0579f18e83>>
 * @relayHash dbfcf8200b0e1736d422ec2d5008eaf0
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/549.0.0-2026-03-03T16:29:43.852Z/usePdpShippingInfoQueryQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type usePdpShippingInfoQueryQuery$variables = {
  afterDisplay?: boolean | null;
  fetchItem?: boolean | null;
  fetchRegionalInfo?: boolean | null;
  fetchUser?: boolean | null;
  isDutiesEstimatesVariant?: boolean | null;
  isTrade?: boolean | null;
  itemId: string;
  itemQuantity?: number | null;
  shippingRegions?: ReadonlyArray<string | null> | null;
  skuId?: string | null;
  userCountryCode?: string | null;
  userId: string;
  userZipCode?: string | null;
};
export type usePdpShippingInfoQueryQuery$data = {
  readonly viewer: {
    readonly geography: {
      readonly countries: ReadonlyArray<{
        readonly abbreviation: string | null;
        readonly name: string | null;
      } | null> | null;
    } | null;
    readonly itemRead?: ReadonlyArray<{
      readonly address?: {
        readonly country: string | null;
        readonly displayCountry: string | null;
      } | null;
      readonly isDutiesEstimateEligible?: boolean | null;
      readonly isItemRTQuoteEligibly?: boolean | null;
      readonly serviceId?: string | null;
      readonly vertical?: VerticalType | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDutiesMessage_item" | "PdpSharedHolidayShippingEstimate_item" | "PdpSharedLowerShippingInfo_item" | "PdpSharedReturns_item" | "PdpSharedShippingAndReturns_item" | "PdpSharedShippingInfoLink_item" | "PdpSharedShippingInfoWrapper_item" | "useShippingPrice_item" | "useShippingType_item" | "useShowReturns_item">;
    } | null> | null;
    readonly regionSelectorEnabled: boolean | null;
    readonly relevantShipping: {
      readonly quoteRequestStatus: string | null;
      readonly shipment: {
        readonly shippingAddress: {
          readonly displayCityStateCountry: string | null;
        } | null;
      } | null;
      readonly shipmentQuote: {
        readonly buyerServiceMethodDisplay: string | null;
        readonly handlingTimeDisplay: string | null;
        readonly serviceMethod: {
          readonly serviceMethodType: string | null;
          readonly serviceType: string | null;
        } | null;
        readonly showQuoteAsPending: boolean | null;
        readonly subTotalAmount: {
          readonly convertedAmountList: ReadonlyArray<{
            readonly amount: number | null;
            readonly currency: Currency | null;
          } | null> | null;
        } | null;
        readonly type: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoLink_shipmentQuote" | "TrackQuoteShown_shipmentQuote">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedHolidayShippingEstimate_relevantShipping">;
    } | null;
    readonly user?: {
      readonly addressBook: {
        readonly addressList: ReadonlyArray<{
          readonly country: string | null;
          readonly displayCountry: string | null;
          readonly zipCode: string | null;
        } | null> | null;
        readonly personalAddress: {
          readonly country: string | null;
          readonly displayCountry: string | null;
          readonly zipCode: string | null;
        } | null;
        readonly proAddress: {
          readonly country: string | null;
          readonly displayCountry: string | null;
          readonly zipCode: string | null;
        } | null;
      } | null;
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPromoCode_user" | "PdpSharedReturns_user" | "PdpSharedShippingAddress_user" | "PdpSharedShippingInfoLink_user" | "useShippingAndReturns_user" | "useUserGeoInfo_user">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDutiesMessage_viewer" | "PdpSharedEstimatedDutiesMessage_viewer" | "PdpSharedHolidayShippingEstimate_viewer" | "PdpSharedLowerShippingInfo_viewer" | "PdpSharedPromoCode_viewer" | "PdpSharedShippingAddress_viewer" | "PdpSharedShippingInfoLink_viewer" | "useShippingPrice_viewer" | "useShippingType_viewer">;
  };
};
export type usePdpShippingInfoQueryQuery = {
  response: usePdpShippingInfoQueryQuery$data;
  variables: usePdpShippingInfoQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "afterDisplay"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchItem"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchRegionalInfo"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isDutiesEstimatesVariant"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemQuantity"
},
v8 = {
  "defaultValue": ([]/*: any*/),
  "kind": "LocalArgument",
  "name": "shippingRegions"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skuId"
},
v10 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v12 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v13 = {
  "kind": "Variable",
  "name": "fetchRegionalInfo",
  "variableName": "fetchRegionalInfo"
},
v14 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v15 = {
  "kind": "Variable",
  "name": "userZipCode",
  "variableName": "userZipCode"
},
v16 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v18 = {
  "kind": "Variable",
  "name": "itemQuantity",
  "variableName": "itemQuantity"
},
v19 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v20 = {
  "alias": "regionSelectorEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "pdpRegionSelector"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"pdpRegionSelector\")"
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Geography",
  "kind": "LinkedField",
  "name": "geography",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GeographyObject",
      "kind": "LinkedField",
      "name": "countries",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "abbreviation",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v23 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v24 = {
  "kind": "Variable",
  "name": "quantity",
  "variableName": "itemQuantity"
},
v25 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
},
v26 = [
  (v22/*: any*/),
  (v23/*: any*/),
  (v17/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quoteRequestStatus",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "displayShort",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "handlingTimeDisplay",
  "storageKey": "handlingTimeDisplay(displayShort:true)"
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    (v30/*: any*/)
  ],
  "storageKey": null
},
v32 = [
  (v31/*: any*/)
],
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "subTotalAmount",
  "plural": false,
  "selections": (v32/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buyerServiceMethodDisplay",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showQuoteAsPending",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceType",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceMethodType",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCityStateCountry",
  "storageKey": null
},
v39 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "itemIds.0",
        "variableName": "itemId"
      }
    ],
    "kind": "ListValue",
    "name": "itemIds"
  }
],
v40 = {
  "kind": "Literal",
  "name": "fetchShippingCostInfo",
  "value": true
},
v41 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v42 = {
  "kind": "Variable",
  "name": "shippingRegions",
  "variableName": "shippingRegions"
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": [
    (v22/*: any*/),
    (v23/*: any*/),
    (v25/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "isItemRTQuoteEligibly",
  "storageKey": null
},
v45 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "country",
      "variableName": "userCountryCode"
    },
    (v25/*: any*/)
  ],
  "kind": "ObjectValue",
  "name": "shippingAddress"
},
v46 = {
  "alias": null,
  "args": [
    (v22/*: any*/),
    (v45/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "isDutiesEstimateEligible",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCountry",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v50 = [
  (v19/*: any*/)
],
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipCode",
  "storageKey": null
},
v52 = [
  (v48/*: any*/),
  (v49/*: any*/),
  (v51/*: any*/)
],
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "buyerTotalAmount",
  "plural": false,
  "selections": (v32/*: any*/),
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v57 = [
  (v49/*: any*/),
  (v51/*: any*/),
  (v43/*: any*/),
  (v54/*: any*/),
  (v48/*: any*/)
],
v58 = {
  "kind": "Variable",
  "name": "skuId",
  "variableName": "skuId"
},
v59 = {
  "kind": "Literal",
  "name": "useAddressResolution",
  "value": true
},
v60 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FinancialAmount",
    "kind": "LinkedField",
    "name": "duty",
    "plural": false,
    "selections": [
      (v30/*: any*/),
      (v31/*: any*/)
    ],
    "storageKey": null
  }
],
v61 = {
  "kind": "Literal",
  "name": "catchNonFatalErrors",
  "value": false
},
v62 = [
  (v22/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePdpShippingInfoQueryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingInfoLink_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedPromoCode_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingAddress_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedDutiesMessage_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedEstimatedDutiesMessage_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedHolidayShippingEstimate_viewer"
          },
          {
            "args": (v16/*: any*/),
            "kind": "FragmentSpread",
            "name": "PdpSharedLowerShippingInfo_viewer"
          },
          {
            "args": (v16/*: any*/),
            "kind": "FragmentSpread",
            "name": "useShippingPrice_viewer"
          },
          {
            "args": [
              (v13/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v14/*: any*/),
              (v19/*: any*/),
              (v15/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "useShippingType_viewer"
          },
          (v20/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": (v26/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "relevantShipping",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PdpSharedHolidayShippingEstimate_relevantShipping"
              },
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingInfoLink_shipmentQuote"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TrackQuoteShown_shipmentQuote"
                  },
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "kind": "LinkedField",
                    "name": "serviceMethod",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "shippingAddress",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "condition": "fetchItem",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v39/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": [
                          (v22/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v18/*: any*/),
                          (v42/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/)
                        ],
                        "kind": "FragmentSpread",
                        "name": "PdpSharedLowerShippingInfo_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedHolidayShippingEstimate_item"
                      },
                      {
                        "args": [
                          (v22/*: any*/),
                          (v40/*: any*/),
                          (v18/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/)
                        ],
                        "kind": "FragmentSpread",
                        "name": "useShippingPrice_item"
                      },
                      {
                        "args": [
                          (v18/*: any*/),
                          (v14/*: any*/),
                          (v19/*: any*/),
                          (v15/*: any*/)
                        ],
                        "kind": "FragmentSpread",
                        "name": "useShippingType_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedShippingInfoLink_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedShippingInfoWrapper_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedDutiesMessage_item"
                      },
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": [
                          (v48/*: any*/),
                          (v49/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedShippingAndReturns_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedReturns_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "useShowReturns_item"
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v50/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedPromoCode_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingInfoLink_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingAddress_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useUserGeoInfo_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedReturns_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useShippingAndReturns_user"
                  },
                  (v43/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AddressBook",
                    "kind": "LinkedField",
                    "name": "addressBook",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "proAddress",
                        "plural": false,
                        "selections": (v52/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "personalAddress",
                        "plural": false,
                        "selections": (v52/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "addressList",
                        "plural": true,
                        "selections": (v52/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v11/*: any*/),
      (v2/*: any*/),
      (v12/*: any*/),
      (v10/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePdpShippingInfoQueryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v17/*: any*/),
              (v19/*: any*/)
            ],
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": [
              (v53/*: any*/),
              (v54/*: any*/)
            ],
            "storageKey": null
          },
          (v21/*: any*/),
          {
            "alias": "pdpHolidayShippingFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "HOLIDAY_SHIPPING"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"HOLIDAY_SHIPPING\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HolidayShippingSettings",
            "kind": "LinkedField",
            "name": "holidayShippingSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deliveryDeadline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "termsAndConditions",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v26/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "relevantShipping",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  (v33/*: any*/),
                  (v54/*: any*/),
                  (v35/*: any*/),
                  (v28/*: any*/),
                  (v55/*: any*/),
                  (v29/*: any*/),
                  (v34/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "kind": "LinkedField",
                    "name": "serviceMethod",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v54/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "shippingAddress",
                "plural": false,
                "selections": [
                  (v49/*: any*/),
                  (v54/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuotes",
                "plural": true,
                "selections": [
                  (v34/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimatedDeliveryDeadline",
                    "storageKey": null
                  },
                  (v54/*: any*/)
                ],
                "storageKey": null
              },
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "shippingAddress",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      (v54/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v54/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v20/*: any*/),
          (v54/*: any*/),
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v22/*: any*/),
                  (v17/*: any*/)
                ],
                "concreteType": "Conversation",
                "kind": "LinkedField",
                "name": "buyerItemConversation",
                "plural": false,
                "selections": [
                  (v43/*: any*/),
                  (v54/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v50/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "expiringPromotion",
                        "plural": false,
                        "selections": [
                          (v56/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/)
                        ],
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v50/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "currentPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "promotion",
                                "plural": false,
                                "selections": [
                                  (v53/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "buyerExpirationDate",
                                    "storageKey": null
                                  },
                                  (v54/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "expiringPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expiringSegmentCode",
                                "storageKey": null
                              },
                              (v56/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v50/*: any*/),
                                "concreteType": "currentPromoSegmentType",
                                "kind": "LinkedField",
                                "name": "currentPromoSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "segmentCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v54/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  (v43/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AddressBook",
                    "kind": "LinkedField",
                    "name": "addressBook",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "addressList",
                        "plural": true,
                        "selections": (v57/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "proAddress",
                        "plural": false,
                        "selections": (v57/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "personalAddress",
                        "plural": false,
                        "selections": (v57/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v54/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isDutiesEstimatesVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "minimumDuty",
                "args": [
                  (v22/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "pricingStrategy",
                    "value": "MINIMUM"
                  },
                  (v24/*: any*/),
                  (v45/*: any*/),
                  (v58/*: any*/),
                  (v59/*: any*/)
                ],
                "concreteType": "EstimatedItemDuties",
                "kind": "LinkedField",
                "name": "estimatedItemDuties",
                "plural": false,
                "selections": (v60/*: any*/),
                "storageKey": null
              },
              {
                "alias": "maximumDuty",
                "args": [
                  (v22/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "pricingStrategy",
                    "value": "MAXIMUM"
                  },
                  (v24/*: any*/),
                  (v45/*: any*/),
                  (v58/*: any*/),
                  (v59/*: any*/)
                ],
                "concreteType": "EstimatedItemDuties",
                "kind": "LinkedField",
                "name": "estimatedItemDuties",
                "plural": false,
                "selections": (v60/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchRegionalInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "regionsInfo",
                "args": [
                  (v23/*: any*/),
                  (v25/*: any*/)
                ],
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RegionsByZipCode",
                    "kind": "LinkedField",
                    "name": "regionsByZipCode",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v54/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchItem",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v39/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v43/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 0
                          },
                          (v42/*: any*/)
                        ],
                        "concreteType": "moreLikeThisConnection",
                        "kind": "LinkedField",
                        "name": "moreLikeThis",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalResults",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v22/*: any*/),
                          (v61/*: any*/),
                          (v41/*: any*/),
                          (v14/*: any*/)
                        ],
                        "concreteType": "ItemDisplayPriceType",
                        "kind": "LinkedField",
                        "name": "displayPrice",
                        "plural": true,
                        "selections": (v32/*: any*/),
                        "storageKey": null
                      },
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShipmentQuote",
                        "kind": "LinkedField",
                        "name": "shipmentQuotes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isComplimentary",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isCalculated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "totalAmount",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConvertedAmounts",
                                "kind": "LinkedField",
                                "name": "convertedAmounts",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "USD",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentServiceMethod",
                            "kind": "LinkedField",
                            "name": "serviceMethod",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Region",
                                "kind": "LinkedField",
                                "name": "region",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "regionName",
                                    "storageKey": null
                                  },
                                  (v54/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v54/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v54/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "useLiveEndpoint",
                            "value": true
                          },
                          (v25/*: any*/)
                        ],
                        "concreteType": "RelevantShippingInfo",
                        "kind": "LinkedField",
                        "name": "relevantShippingInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "kind": "LinkedField",
                            "name": "shipmentQuote",
                            "plural": false,
                            "selections": [
                              (v55/*: any*/),
                              (v54/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "leadTimeMax",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": [
                          (v49/*: any*/),
                          (v54/*: any*/),
                          (v48/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "priceType",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "buyerId",
                            "value": ""
                          },
                          (v61/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "isTrade",
                            "value": false
                          }
                        ],
                        "concreteType": "ItemDisplayPriceType",
                        "kind": "LinkedField",
                        "name": "displayPrice",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textType",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "displayPrice(buyerId:\"\",catchNonFatalErrors:false,isTrade:false)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasShipmentQuotes",
                        "storageKey": null
                      },
                      {
                        "alias": "itemIsOnHold",
                        "args": (v62/*: any*/),
                        "kind": "ScalarField",
                        "name": "isOnHold",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPrivateListing",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "defaultSkuId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAuctionEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v62/*: any*/),
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "lastActiveTransaction",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isAuctionOrderType",
                            "storageKey": null
                          },
                          (v54/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v46/*: any*/),
                      (v44/*: any*/),
                      {
                        "alias": null,
                        "args": (v50/*: any*/),
                        "concreteType": "ReturnPolicy",
                        "kind": "LinkedField",
                        "name": "returnPolicy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "includeEuReturns",
                                "value": true
                              },
                              (v14/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "returnDays",
                            "storageKey": null
                          },
                          (v54/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v54/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/549.0.0-2026-03-03T16:29:43.852Z/usePdpShippingInfoQueryQuery",
    "metadata": {},
    "name": "usePdpShippingInfoQueryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a30ddd6ec6c89963a7457723f28751f4";

export default node;
